/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { later } from '@ember/runloop';
import { action, computed } from '@ember/object';
import { sort } from '@ember/object/computed';
import { tablePrintCss } from 'linced-app/utils/table';
import {
  cleanExcelSheetName,
  cleanFileName,
} from '@linc-technologies/linced-common/utils/file-names';
import moment from 'moment';
import { naturalSort } from '@linc-technologies/linced-common/utils/sorting';

export default class NewPreviousClassController extends Controller {
  @service
  excel;

  title = 'New to Previous Class Lists';
  year = moment().format('YYYY');

  @sort('model.newHomerooms', naturalSort('name'))
  sortedNewHomerooms;

  @computed('model.prevHomerooms.[]')
  get learnerToPrevClass() {
    return this.model.prevHomerooms.reduce((map, room) => {
      room.currentLearners.forEach((learner) => {
        map[learner.personId] = room.name;
      });

      return map;
    }, {});
  }

  @action
  downloadFullXlsx() {
    let sheets = [];

    this.sortedNewHomerooms.forEach((homeroom) => {
      sheets.push({
        name: cleanExcelSheetName(homeroom.name),
        data: this.getExportData(homeroom),
      });
    });

    let fileName = `${this.title} ${moment().format('YYYY-MM-DD')}.xlsx`;

    this.excel.export(sheets, {
      multiSheet: true,
      fileName: cleanFileName(fileName),
    });
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let classLists = document.querySelectorAll('.class-list');

    printer.document.body.innerHTML = tablePrintCss;

    printer.document.body.innerHTML += `<style>.table-tools button { display: none; }</style>`;

    classLists.forEach((classList, index) => {
      if (index !== 0) {
        printer.document.body.innerHTML += `<div style="page-break-before: always"></div>`;
      }

      printer.document.body.innerHTML += classList.outerHTML;
    });

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  getExportData(homeroom) {
    let data = [];

    // Class info
    data.push([`${homeroom.name}`]);

    // Column headers
    data.push([
      'Family Name',
      'First Name',
      'Current Year Level',
      `${this.year} Class`,
    ]);

    // Data
    homeroom.currentLearners.forEach((learner) => {
      data.push([
        learner.person.lastName,
        learner.person.firstName,
        learner.person.currentYearLevel,
        this.learnerToPrevClass[learner.personId],
      ]);
    });

    return data;
  }
}
